export enum UserAction {
    Login = "Login",
    Logout = "Logout",
    NavigateTo = "NavigateTo",
    NavigateToTask = "NavigateToTask",
    SwitchToTableView = "SwitchToTableView",
    SwitchToCardView = "SwitchToCardView",
    SwitchToSAView = "SwitchToSAView",
    SwitchToMUView = "SwitchToMUView",
    AddComment = "AddComment",
    AddCommentWithUpload = "AddCommentWithUpload",
    EditComment = "EditComment",
    DeleteComment = "DeleteComment",
    DownloadFile = "DownloadFile"
}
